import createResource from './createResource';
import patientsResource from './patientsResource';
import { Message } from './types';
import usersResource from './usersResource';

const messagesResource = createResource<Message>({
  key: 'messages',
  url: '/messages',
  lookups: {
    patient: patientsResource,
    recipient: usersResource,
  },
  processStrategy: (data) => ({
    ...data,
    $toString: data.text,
  }),
});

export default messagesResource;
